// ROW 1 — ICON (morphs in when an Iconify icon is selected: FabricImage with
// isIcon). R2.6 (owner directive §1, 2026-07-21): the tint chip is GONE from
// Row 1 — the single color home is Row 2's STYLE chip (objColor), which routes
// icons to changeIconColor (the tint verb) exactly as this chip did. In its
// place, the leading "Change icon" button (owner directive §3): swap the icon
// while KEEPING the current tint + every effect (editor.swapIcon — the
// changeIconColor engine posture with a new iconName). Flips complete the
// branch. Crop/frame/remove-BG are deliberately absent: icons are decorative
// cutouts, not photos.

const iconRow1 = {
  id: 'icon-row1',
  row: 1,
  groups: [
    {
      // Owner directive §3: open the ObjectSwapModal (icon browser — the left
      // panel's iconify search reused). The pick fires icon.openSwap →
      // editor.swapIcon, which re-fetches the NEW icon at the CURRENT tint and
      // carries shadow + the whole data bag (effects re-derive from the new
      // alpha via reattachFxDeep). Every icon is swappable, so no showWhen.
      id: 'iconChange',
      label: 'Change',
      drawerSection: null,
      neverCollapse: true,
      controls: [
        { id: 'changeIcon', kind: 'button', label: 'Change icon — pick a new one, keep the color and effects', icon: 'star', text: 'Change icon', handler: 'icon.openSwap' },
      ],
    },
    {
      id: 'iconFlip',
      label: 'Flip',
      drawerSection: null,
      collapsePriority: 1,
      controls: [
        { id: 'iconFlipH', kind: 'button', label: 'Flip horizontal', icon: 'flipH', handler: 'object.flipH' },
        { id: 'iconFlipV', kind: 'button', label: 'Flip vertical', icon: 'flipV', handler: 'object.flipV' },
      ],
    },
  ],
};

export default iconRow1;
